var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"pb-5"},[_c('Header',{attrs:{"quantity":_vm.quantity}}),_c('Banner'),_c('router-view',{on:{"addToBasket":_vm.addToBasket}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }